// removed by extract-text-webpack-plugin
module.exports = {"root":"ProductCarousel-module-root-u5ZB7","carousel-item":"ProductCarousel-module-carousel-item-1dCWG","carouselItem":"ProductCarousel-module-carousel-item-1dCWG","item-image":"ProductCarousel-module-item-image-1Rj1x","itemImage":"ProductCarousel-module-item-image-1Rj1x"};


//////////////////
// WEBPACK FOOTER
// ./src/pages/Product/components/ProductCarousel/ProductCarousel.module.scss
// module id = 1203
// module chunks = 0